module.exports = __webpack_public_path__ + "fonts/font.4c48503b.woff";